/* eslint-disable */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generatePdfForAtencion = async (datosInfoImprimir, datosPaciente, evaluacionBoolean) => {

    //margin: [izquierda, arriba, derecha, abajo]

    const docDefinition = {
        pageSize: 'A4',
        pageMargins: [30, 30, 30, 30],
        content: [
            { text: 'CONSULTA EXTERNA - ANAMNESIS Y EXAMEN FÍSICO', style: 'header' },
            { text: 'Centro de Especialidades "P. Emilio Catalán"', style: 'subheader' },
            generateTable(datosInfoImprimir, datosPaciente),

            // Título de signos vitales fuera de la tabla
            { text: 'SIGNOS VITALES', alignment: 'center', bold: true, fontSize: 9, alignment: 'left', fillColor: '#0078be', margin: [0, 2, 0, 4] },
            generateTableSignosVitales(datosInfoImprimir),
            generateTableDiagnostico(datosInfoImprimir),

            // Condición para evaluar si se debe agregar la tabla de evolución
            ...(evaluacionBoolean ? [generateTableEvolucion(datosInfoImprimir)] : []),
            generateTableDoctor(datosInfoImprimir)
        ],
        styles: {
            header: { fontSize: 16, bold: true, alignment: 'center', margin: [0, 0, 0, 5] },
            subheader: { fontSize: 12, bold: true, alignment: 'center', margin: [0, 0, 0, 10] },
            section: { fontSize: 10, bold: true, margin: [0, 10, 0, 0] },
            content: { fontSize: 9, margin: [0, 1, 0, 2] }
        },
        defaultStyle: {
            fontSize: 9,
            columnGap: 10
        },
        pageBreakBefore: function (currentNode, followingNodesOnPage) {
            return currentNode.headlineLevel === 1 && followingNodesOnPage.length > 0;
        }
    };

    pdfMake.createPdf(docDefinition).open();
};

function generateTable(datosInfoImprimir, datosPaciente) {
    const headerStyle = { color: '#ffffff', fillColor: '#0078be', bold: true, fontSize: 10 };
    const cellStyle = { fontSize: 10 };
    const cellUnion = { color: '#ffffff', fillColor: '#0078be', fontSize: 10, margin: [0, 0, 0, 0], bold: true, colSpan: 4 };
    const cellVacia = { colSpan: 4, border: [false, false, false, false], margin: [0, 2, 0, 0] };
    const cellGrande3Filas = { fontSize: 10, alignment: 'justify', colSpan: 4, margin: [0, 0, 0, 4] };


    console.log(datosInfoImprimir)

    const obtenerAntecedentes = (tipo) =>
        datosInfoImprimir.antecedentes
            .filter(ant => ant.tipo === tipo)
            .map(ant => ant.detalle ? `${ant.enfermedad} (${ant.detalle})` : ant.enfermedad)
            .join(", ")
            .toUpperCase();

    const antecedentePersonal = obtenerAntecedentes("Personal");
    const antecedenteFamiliar = obtenerAntecedentes("Familiar");

    const obtenerDetalles = (tipo) =>
        (datosInfoImprimir.organos_fisicos[tipo] || [])
            .map(item => item.detalle)
            .join(", ")
            .toUpperCase();

    const obtenerObservacion = (tipo) => {
        if (tipo === "Organos") {
            return (datosInfoImprimir.organos_fisicos.observacionOrganos || "").toUpperCase();
        } else if (tipo === "Fisicos") {
            return (datosInfoImprimir.organos_fisicos.observacionOrganosFisicos || "").toUpperCase();
        }
        return "";
    };

    const detallesOrganos = obtenerDetalles("Organos");
    const detallesFisicos = obtenerDetalles("Fisicos");
    const observacionOrganos = obtenerObservacion("Organos");
    const observacionFisicos = obtenerObservacion("Fisicos");

    let body = [
        [{ text: 'ESTABLECIMIENTO', ...headerStyle }, { text: 'NOMBRES', ...headerStyle }, { text: 'SEXO', ...headerStyle }, { text: 'HISTORIA CLINICA', ...headerStyle }],
        [{ text: 'P. EMILIO CATALÁN', ...cellStyle }, { text: datosPaciente.nombres + ' ' + datosPaciente.apellidos, ...cellStyle }, { text: datosPaciente.sexo, ...cellStyle }, { text: datosPaciente.cedula, ...cellStyle }],
        [{ text: '', ...cellVacia }, {}, {}, {}],
        [{ text: 'MOTIVO DE CONSULTA', ...cellUnion, keepWithNextRows: 1 }, {}, {}, {}],
        [{ text: datosInfoImprimir.motivo_consulta[0].motivo_atencion, ...cellGrande3Filas }, {}, {}, {}],
        [{ text: '', ...cellVacia }, {}, {}, {}]
    ];

    // Sección de antecedentes
    if (datosInfoImprimir.medico.especialidad === 'ODONTOLOGIA') {
        body.push(
            [{ text: 'ANTECEDENTES ESTOMATOGNATICO', ...cellUnion, keepWithNextRows: 1 }, {}, {}, {}],
            [{ text: antecedentePersonal, ...cellGrande3Filas }, {}, {}, {}],
            [{ text: '', ...cellVacia }, {}, {}, {}]
        );
    } else {
        body.push(
            [{ text: 'ANTECEDENTES PERSONALES', ...cellUnion, keepWithNextRows: 1 }, {}, {}, {}],
            [{ text: antecedentePersonal, ...cellGrande3Filas }, {}, {}, {}],
            [{ text: '', ...cellVacia }, {}, {}, {}],
            [{ text: 'ANTECEDENTES FAMILIARES', ...cellUnion, keepWithNextRows: 1 }, {}, {}, {}],
            [{ text: antecedenteFamiliar, ...cellGrande3Filas }, {}, {}, {}],
            [{ text: '', ...cellVacia }, {}, {}, {}]
        );
    }

    // SIEMPRE agregar revisión de órganos después de antecedentes
    body.push(
        [{ text: 'ENFERMEDAD O PROBLEMA ACTUAL', ...cellUnion, keepWithNextRows: 1 }, {}, {}, {}],
        [{ text: datosInfoImprimir.motivo_consulta[0].anamnesis, ...cellGrande3Filas }, {}, {}, {}],
        [{ text: '', ...cellVacia }, {}, {}, {}]
    );

    // Solo si NO es odontología, agregar revisión de órganos
    if (datosInfoImprimir.medico.especialidad !== 'ODONTOLOGIA') {
        body.push(
            [{ text: 'REVISIÓN DE ÓRGANOS', ...cellUnion, keepWithNextRows: 1 }, {}, {}, {}],
            [{ text: detallesOrganos + (observacionOrganos ? ' (' + observacionOrganos + ') / ' : ' / ') + detallesFisicos + (observacionFisicos ? ' (' + observacionFisicos + ') ' : ''), ...cellGrande3Filas }, {}, {}, {}]
        );
    }

    return {
        table: {
            widths: [60, 170, 90, 180],
            body
        }
    };
}

function generateTableSignosVitales(datosInfoImprimir) {
    const headerStyle = { fillColor: '#f3f2f5', bold: true, fontSize: 9, alignment: 'left', border: [true, true, true, true] };
    const cellStyle = { fontSize: 10, alignment: 'left', margin: [0, 0, 0, 0] };
    const cellVacia = { colSpan: 6, border: [false, false, false, false], margin: [0, 2, 0, 0] };

    return {
        table: {
            widths: [90, 70, 90, 70, 90, 71],
            body: [
                // Fila 1
                [
                    { text: 'Peso:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.peso, ...cellStyle, alignment: 'center' },
                    { text: 'Talla:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.talla, ...cellStyle, alignment: 'center' },
                    { text: 'IMC:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.imc, ...cellStyle, alignment: 'center' }
                ],
                // Fila 2
                [
                    { text: 'Per. Abd:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.perimetro_abdominal, ...cellStyle, alignment: 'center' },
                    { text: 'Per. Cef:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.perimetro_cefalico, ...cellStyle, alignment: 'center' },
                    { text: 'Pr. Sist:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.presion_sistolica, ...cellStyle, alignment: 'center' }
                ],
                // Fila 3
                [
                    { text: 'Pr. Dist:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.presion_diastolica, ...cellStyle, alignment: 'center' },
                    { text: 'Pr. Med:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.presion_media, ...cellStyle, alignment: 'center' },
                    { text: 'Temp:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.temperatura, ...cellStyle, alignment: 'center' }
                ],
                // Fila 4
                [
                    { text: 'FC:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.frecuencia_cardiaca, ...cellStyle, alignment: 'center' },
                    { text: 'Sat:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.saturacion_oxigeno, ...cellStyle, alignment: 'center' },
                    { text: 'Fr:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.frecuencia_respiratoria, ...cellStyle, alignment: 'center' }
                ],
                // Fila 5
                [
                    { text: 'GC:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.glucosa_capilar, ...cellStyle, alignment: 'center' },
                    { text: 'VHB:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.hemoglobina, ...cellStyle, alignment: 'center' },
                    { text: 'VHC:', ...headerStyle }, { text: datosInfoImprimir.signos_vitales.hemoglobina_corregida, ...cellStyle, alignment: 'center' }
                ],
                [
                    { text: '', ...cellVacia },
                    {}, {}, {}, {}, {}
                ],
            ]
        }
    };
}

function generateTableDiagnostico(datosInfoImprimir) {
    const headerStyle = { fillColor: '#f3f2f5', bold: true, fontSize: 9, alignment: 'left', border: [true, true, true, true] };
    const cellUnion = { color: '#ffffff', fillColor: '#0078be', fontSize: 10, margin: [0, 0, 0, 0], bold: true, colSpan: 4 };
    const cellVacia = { colSpan: 4, border: [false, false, false, false], margin: [0, 2, 0, 0] };
    const cellGrande3Filas = { fontSize: 10, alignment: 'justify', colSpan: 4, margin: [0, 0, 0, 4] };

    // Construcción de la tabla de diagnósticos
    let diagnosticos = datosInfoImprimir.diagnosticos || [];
    let diagnosticosRows = diagnosticos.length > 0
        ? diagnosticos.map(d => ([
            { text: (d.cie_cod || '').toUpperCase(), fontSize: 9 },
            { text: (d.enfermedad || '').toUpperCase(), fontSize: 9 },
            { text: (d.tipo || '').toUpperCase(), fontSize: 9 },
            { text: (d.description || '').toUpperCase(), fontSize: 9 }
        ]))
        : [[{ text: 'SIN REGISTROS', colSpan: 4, alignment: 'center', fontSize: 9 }, {}, {}, {}]];

    // Construcción de la tabla de tratamiento
    let tratamiento = datosInfoImprimir.tratamiento?.map(t => t.tratamiento).join('\n') || 'SIN TRATAMIENTO';

    // Armado del body
    let body = [
        [{ text: 'DIAGNÓSTICO', ...cellUnion }, {}, {}, {}],
        [
            { text: 'CÓDIGO', ...headerStyle },
            { text: 'CIE-10', ...headerStyle },
            { text: 'TIPO', ...headerStyle },
            { text: 'DESCRIPCIÓN', ...headerStyle }
        ],
        ...diagnosticosRows,
        [{ text: '', ...cellVacia }, {}, {}, {}],
    ];

    // Si es odontología, agregar la tabla del odontograma antes del tratamiento
    if (datosInfoImprimir.medico.especialidad === 'ODONTOLOGIA' && datosInfoImprimir.odontograma && datosInfoImprimir.odontograma.length > 0) {
        body.push(
            [{ text: 'ODONTOGRAMA', ...cellUnion }, {}, {}, {}],
            [
                {
                    colSpan: 4,
                    alignment: 'center',
                    margin: [0, 5, 0, 5],
                    table: createOdontogramaTable(datosInfoImprimir.odontograma).table
                }, {}, {}, {}
            ],
            [{ text: '', ...cellVacia }, {}, {}, {}]
        );
    }

    // Ahora sí, el tratamiento
    body.push(
        [{ text: 'TRATAMIENTO', ...cellUnion }, {}, {}, {}],
        [{ text: tratamiento, ...cellGrande3Filas }, {}, {}, {}],
        [{ text: '', ...cellVacia }, {}, {}, {}]
    );

    return {
        table: {
            widths: [60, 170, 90, 180],
            body
        }
    };
}

function generateTableEvolucion(datosInfoImprimir) {
    const headerStyle = { fillColor: '#f3f2f5', bold: true, fontSize: 9, alignment: 'left', border: [true, true, true, true] };
    const cellUnion = { color: '#ffffff', fillColor: '#0078be', fontSize: 10, margin: [0, 0, 0, 0], bold: true, colSpan: 3 };

    let evolucion = datosInfoImprimir.evolucion || [];

    let evaluacionRows = evolucion.length > 0
        ? evolucion.map(d => ([
            { text: (d.fecha || '').toUpperCase(), fontSize: 9 },
            { text: (d.evolucion || '').toUpperCase(), fontSize: 9 },
            { text: (d.medico || '').toUpperCase(), fontSize: 9 }
        ]))
        : [[{ text: 'SIN REGISTROS', colSpan: 3, alignment: 'center', fontSize: 9 }, {}, {}]];

    return {
        table: {
            widths: [90, '*', 170], // Se mantiene el ancho de columnas
            body: [
                [{ text: 'EVOLUCIÓN', ...cellUnion }, {}, {}], // Ajustado colSpan a 3
                [
                    { text: 'FECHA', ...headerStyle },
                    { text: 'EVOLUCIÓN', ...headerStyle },
                    { text: 'DOCTOR', ...headerStyle }
                ],
                ...evaluacionRows
            ]
        }
    };
}

function generateTableDoctor(datosInfoImprimir) {
    const headerStyle = { color: '#ffffff', fillColor: '#0078be', bold: true, fontSize: 10 };
    const cellVacia = { colSpan: 4, border: [false, false, false, false], margin: [0, 2, 0, 6] };
    const cellStyle = { fontSize: 10 };

    return {
        table: {
            widths: [100, 100, '*', 120],
            body: [
                [
                    { text: '', ...cellVacia },
                    {}, {}, {}
                ],
                [
                    { text: 'FECHA', ...headerStyle },
                    { text: 'ESPECIALIDAD', ...headerStyle },
                    { text: 'NOMBRE DEL PROFESIONAL', ...headerStyle },
                    { text: 'FIRMA', ...headerStyle }
                ],
                [
                    { text: datosInfoImprimir.date_at, ...cellStyle },
                    { text: datosInfoImprimir.medico.especialidad, ...cellStyle },
                    { text: datosInfoImprimir.medico.doctor, ...cellStyle },
                    { text: '', ...cellStyle }
                ]
            ]
        }
    }
}

// Traduce la sección del diente a español
function translateSection(section) {
    const translations = {
        'center': 'Centro',
        'top': 'Superior',
        'right': 'Derecha',
        'bottom': 'Inferior',
        'left': 'Izquierda'
    };
    return translations[section] || section;
}

// Verifica si el diente extraído ya fue mostrado
function isDuplicateExtracted(item, currentIndex, odontograma) {
    if (item.color !== 'cross') return false;
    for (let i = 0; i < currentIndex; i++) {
        if (odontograma[i].numero_diente === item.numero_diente && odontograma[i].color === 'cross') {
            return true;
        }
    }
    return false;
}

// Crea la tabla del odontograma
function createOdontogramaTable(odontograma) {
    const table = {
        table: {
            widths: ['*', '*', '*'],
            body: [
                [
                    { text: 'Diente', style: 'tableHeader' },
                    { text: 'Posición', style: 'tableHeader' },
                    { text: 'Estado', style: 'tableHeader' }
                ]
            ]
        },
        layout: 'lightHorizontalLines'
    };

    odontograma.forEach((item, index) => {
        if (!isDuplicateExtracted(item, index, odontograma)) {
            const estado = item.color === 'blue' ? 'Restauración' :
                item.color === 'red' ? 'Caries' :
                item.color === 'purple' ? 'Endodoncia' :
                item.color === 'green' ? 'Sellante' :
                'Extraído';

            table.table.body.push([
                { text: item.numero_diente.toString(), alignment: 'center' },
                {
                    text: item.color === 'cross' ? 'Total' : translateSection(item.seccion),
                    alignment: 'center'
                },
                {
                    text: estado,
                    alignment: 'center'
                }
            ]);
        }
    });

    return table;
}